export const REVERSAL_WINDOW_HOURS = 120;

/**
 * Reversal is available only within REVERSAL_WINDOW_HOURS of transfer.
 * @param {string|Date|null|undefined} transferredDate
 * @param {Date} [currentDate=new Date()]
 * @returns {boolean}
 */
export function canBeDispute(transferredDate, currentDate = new Date()) {
  if (!transferredDate) {
    return false;
  }

  const transferDate = new Date(transferredDate);
  const hoursElapsed =
    (currentDate.getTime() - transferDate.getTime()) / 3600000;

  return hoursElapsed <= REVERSAL_WINDOW_HOURS;
}
